/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Hero_OverlineInputs */

const en_cmp_hero_overline = /** @type {(inputs: Cmp_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison`)
};

const id_cmp_hero_overline = /** @type {(inputs: Cmp_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan`)
};

/**
* | output |
* | --- |
* | "Comparison" |
*
* @param {Cmp_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_hero_overline = /** @type {((inputs?: Cmp_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_hero_overline(inputs)
	return en_cmp_hero_overline(inputs)
});